import { render, staticRenderFns } from "./MedicalAppointmentPage.vue?vue&type=template&id=de4ad150&"
import script from "./MedicalAppointmentPage.vue?vue&type=script&lang=js&"
export * from "./MedicalAppointmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports